<!-- Компонент фільтру під нову шапку -->

<template>
    
    <div class="row g-2" >
        

        <!-- Пошук -->
        <!-- <div 
            v-if="objFilter.checkSearch"
            class="col-lg-2 col-auto" 
        >
            <div class="search-box" >
                <input type="text" class="form-control search" id="search-task-options" placeholder="Пошук">
                <i class="ri-search-line search-icon"></i>
            </div>
        </div> -->

        <div class="col-lg-2 col-auto">
            <ul class="pagination pagination-separated justify-content-center justify-content-sm-start mb-sm-0">
                <div class="pagination-wrap hstack gap-2" style="margin-right:5px;" >
                <select class="form-select mb-0" v-model="limit" @change="this.$emit('changelimit', limit)">
                    <option v-for="item in limits" :key="item" :value="item.value" >{{item.value}}</option>
                </select>
                </div>
                <li v-for="(pageNumber, index) in objPages.links" :key="index" :class="`page-item copy ${pageNumber.current == 'true' ? 'active' : null}`">
                    <a class="page-link" @click="this.$emit('getdata',pageNumber.page)">{{ pageNumber.page }}</a>
                </li>
            </ul>
        </div>

        <div class="col-auto ms-sm-auto" >
            
            <div class="list-grid-nav hstack gap-1" v-if="this.objFilter.checkChangeTab === true">

                <!-- Кнопка відображення grid -->
                <button 
                    type="button" 
                    id="grid-view-button" 
                    :class="`btn btn-soft-info nav-link btn-icon fs-14 ${objFilter.defaultType == 0 ? 'active' : ''} filter-button`" 
                    @click="form.typeList = 0, this.$emit('changeTab', form.typeList)"
                >
                    <i class="ri-grid-fill"></i>
                </button>

                <!-- Кнопка відображення таблицею -->
                <button 
                    type="button" 
                    id="list-view-button" 
                    :class="`btn btn-soft-info nav-link  btn-icon fs-14 ${objFilter.defaultType == 1 ? 'active' : ''} filter-button`" 
                    @click="form.typeList = 1, this.$emit('changeTab', form.typeList)"
                >
                    <i class="ri-list-unordered"></i>
                </button>
                
            </div>

        </div>
        
    </div>
    

</template>

<script>
export default {
    props: ["objFilter", "objPages"],
    data() {
        return {
            form: {
                typeList: null, // 0 - grid, 1 - list
            },
            limit: '10',
            limits: [
                { value: '5'},
                { value: '10'},
                { value: '25'},
                { value: '50'},
                { value: '75'},
                { value: '100'},
            ],
        }
    },
    created(){
        this.form.typeList = this.objFilter.defaultType ? this.objFilter.defaultType : 1
    }
}
</script>